module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/article02-6424f0e7ba4ea3189b5520e99db43957.png";